import * as React from 'react';
import { cn } from '@/lib/utils';

/** Wraps the table so wide content scrolls inside itself, never the page body. */
export function TableWrap({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'scrollbar-thin overflow-x-auto rounded-lg border border-[var(--border)] bg-[var(--card)]',
        className,
      )}
      {...props}
    />
  );
}

export const Table = ({ className, ...p }: React.TableHTMLAttributes<HTMLTableElement>) => (
  <table className={cn('w-full text-sm', className)} {...p} />
);

/** The recessed column head an operator tool wants: small, spaced, quiet. */
export const THead = ({ className, ...p }: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <thead
    className={cn(
      'table-head border-b border-[var(--border)] bg-[var(--surface-sunken)] text-[var(--muted-foreground)]',
      className,
    )}
    {...p}
  />
);

export const TH = ({ className, ...p }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
  <th className={cn('px-3 py-2 text-start font-semibold', className)} {...p} />
);

/** `ComponentPropsWithRef` so a drag-and-drop row can attach its node ref here. */
export const TR = ({ className, ...p }: React.ComponentPropsWithRef<'tr'>) => (
  <tr
    className={cn(
      'border-b border-[var(--border)] last:border-0 hover:bg-[var(--surface-hover)]',
      className,
    )}
    {...p}
  />
);

export const TD = ({ className, ...p }: React.TdHTMLAttributes<HTMLTableCellElement>) => (
  <td className={cn('px-3 py-2 align-top', className)} {...p} />
);

export function TableEmpty({ colSpan, children }: { colSpan: number; children: React.ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} className="p-8 text-center text-[var(--muted-foreground)]">
        {children}
      </td>
    </tr>
  );
}
